import { render, staticRenderFns } from "./recordfields.vue?vue&type=template&id=b08793bc&scoped=true"
import script from "./recordfields.vue?vue&type=script&lang=js"
export * from "./recordfields.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b08793bc",
  null
  
)

export default component.exports